module.exports = __webpack_public_path__ + "media/images/landkit/brand-b477545a2038a0e4cbaaddd49baeaae0.svg";